import React from 'react';
import { Spin } from 'antd';
const PageLoading: React.FC = () => (
  <div style={{ display: 'flex', textAlign: 'center', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
    <Spin size="large" />
  </div>
);
export default PageLoading;
